import { CANONICAL_VISIBILITY, parseCanonicalVisibility } from "../constants/visibility";
import { CANONICAL_USER_ID_REGEX } from "./profileRoutes";

export const EMPTY_USER_FOLLOW_STATUS = Object.freeze({
    following: false,
    followerCount: null,
    followedAt: null,
});

export const normalizeFollowerCount = (value) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    const count = Number(value);
    return Number.isFinite(count) && count >= 0 ? Math.floor(count) : null;
};

export const normalizeUserFollowStatus = (status) => ({
    following: Boolean(status?.following),
    followerCount: normalizeFollowerCount(status?.followerCount),
    followedAt: status?.followedAt || null,
});

export const canCurrentViewerFollowUser = ({
    targetUserId,
    viewerUserId,
    currentUserCanFollow,
    visibility,
    privacy,
} = {}) => {
    const target = typeof targetUserId === "string" ? targetUserId.trim() : "";
    const viewer = typeof viewerUserId === "string" ? viewerUserId.trim() : "";
    if (!CANONICAL_USER_ID_REGEX.test(target) || !CANONICAL_USER_ID_REGEX.test(viewer) || target === viewer) {
        return false;
    }

    if (typeof currentUserCanFollow === "boolean") {
        return currentUserCanFollow;
    }

    const targetVisibility = parseCanonicalVisibility(visibility ?? privacy);
    return targetVisibility === CANONICAL_VISIBILITY.PUBLIC;
};
